import PNLReportsActions from "../../../../redux/actions/Reports/PNLReport";
import DashboardSummaryActions from "../../../../redux/actions/Reports/DashboardSummary";
export const PNLDashBoardActions = new DashboardSummaryActions();
export default () => {
    return new PNLReportsActions();
};
